
import React from 'react';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import Dashboard from '../../../../component/Dashboard';
import CreateUnderWriterForm from './forms';
import { submitCreateAdminForm, doCreateAdminRes } from '../../../../actions/createAdminActions';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

class CreateUnderwriterAdmin extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      borkerInfo: {},
      tabIndex: 0
    }
  }
  componentDidMount() {
    let brokerData = this.props.location.state.borkerAllData;
    this.setState({
      borkerInfo: brokerData,
      tabIndex: this.props.location.state.tabIndex
    });
    console.log(brokerData)
  }
  
  static getDerivedStateFromProps(props, state) {
		if (props.createAdminRes) {
      if (props.createAdminRes.data && props.createAdminRes.data.createAdmin) {
        if (props.createAdminRes.data.createAdmin.message === 'Success') {
          // props.goBack();
          props.history.push({
            pathname: `/system-setting`,
            state: {
                tabIndex: state.tabIndex,
            }
          });
        }
      }
    }
		return null
	}
  submitForm = (data) => {
    data.organization_name = this.state.borkerInfo.name;
    data.type = this.state.borkerInfo.type;
    data.organization_mpid = this.state.borkerInfo.mpid;
    this.props.handleFormSubmit(data);
  }
  goToBack = () => {
    this.props.history.push({
      pathname: `/system-setting`,
      state: {
        tabIndex: this.state.tabIndex,
      }
    });
  }
  render() {
    return (
      <Dashboard title="Create Underwriter User" >
        <div className="admin_offering_content">
        <div>
          <h3 style={{ marginLeft: '16px', cursor: 'pointer', color: '#8DC73F'}}>
            <ArrowBackIosIcon onClick={() => this.goToBack()} style={{ cursor: 'pointer' }} />  Add Underwriter User 
          </h3>
        </div>
          <CreateUnderWriterForm handleFormSubmit={(data) => this.submitForm(data)} />
        </div>
      </Dashboard>
    );
  }
}

CreateUnderwriterAdmin.propTypes = {
  goBack: PropTypes.func,
  handleFormSubmit: PropTypes.func,
  createAdminRes: PropTypes.any,
};


const mapStateToProps = createStructuredSelector({
  createAdminRes: doCreateAdminRes,
});


function mapDispatchToProps(dispatch, ownProps) {
  return {
    goBack: () => { ownProps.history.goBack(); },
    handleFormSubmit: (data) => dispatch(submitCreateAdminForm(data)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateUnderwriterAdmin);
